// Authentication service - handles all auth-related API calls
import api from './api';

export const authService = {
  // Register new user
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  // Send OTP verification
  verifyOtp: async (email, otp) => {
    const response = await api.post('/auth/verify-otp', { email, otp });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.user.id);
    }
    return response.data;
  },

  // Resend OTP
  resendOtp: async (email) => {
    const response = await api.post('/auth/resend-otp', { email });
    return response.data;
  },

  // Login
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.user.id);
    }
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
  },

  // Get current user info
  getCurrentUser: () => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');
    return { userId, token, isAuthenticated: !!(userId && token) };
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!(localStorage.getItem('token') && localStorage.getItem('userId'));
  },
};

export default authService;
